import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { PURGE_COUNTDOWN_SECONDS } from '../constants/purge-checkpoint'

type PurgeCheckpointDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  isPurging: boolean
  onContinue: () => void
}

/** Confirmation for purging the current spread's checkpoint data. */
export function PurgeCheckpointDialog({
  open,
  onOpenChange,
  isPurging,
  onContinue,
}: PurgeCheckpointDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Purge Checkpoint Data</DialogTitle>
          <DialogDescription>
            This will permanently purge this spread&apos;s checkpoint data. This action cannot be
            undone. The page will refresh {PURGE_COUNTDOWN_SECONDS} seconds after you continue.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPurging}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onContinue} disabled={isPurging}>
            {isPurging && (
              <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" aria-hidden="true" />
            )}
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
